import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, isSubscribed } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User, Shield } from "lucide-react";
import { LOGO_URL } from "@/lib/branding";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const subscribed = isSubscribed(user);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <img src={LOGO_URL} alt="ball0ut.ent" className="h-10 w-10 object-contain drop-shadow-[0_0_8px_rgba(255,200,0,0.35)]" />
          <span className="font-display text-2xl tracking-tight">
            <span className="text-white">BALL0UT</span>
            <span className="text-brand-primary neon-text">TV</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm uppercase tracking-[0.18em] font-medium">
          <Link data-testid="nav-home" to="/" className={`hover:text-white ${loc.pathname === "/" ? "text-white" : "text-brand-muted"}`}>Home</Link>
          <Link data-testid="nav-browse" to="/browse" className={`hover:text-white ${loc.pathname.startsWith("/browse") ? "text-white" : "text-brand-muted"}`}>Browse</Link>
          <Link data-testid="nav-show" to="/show/boyz-gone-wild" className={`hover:text-white ${loc.pathname.startsWith("/show") ? "text-white" : "text-brand-muted"}`}>The Show</Link>
          {user && user !== false && user.role === "admin" && (
            <Link data-testid="nav-admin" to="/admin" className={`hover:text-white flex items-center gap-1 ${loc.pathname.startsWith("/admin") ? "text-white" : "text-brand-muted"}`}>
              <Shield className="h-3.5 w-3.5" /> Admin
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {!user || user === false ? (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="text-white hover:bg-white/10 rounded-none">Sign in</Button>
              </Link>
              <Link to="/subscribe" data-testid="nav-subscribe-cta">
                <Button className="bg-brand-primary hover:bg-brand-primaryHover text-white rounded-none px-5 font-semibold tracking-wide">
                  Subscribe
                </Button>
              </Link>
            </>
          ) : (
            <>
              {!subscribed && user.role !== "admin" && (
                <Link to="/subscribe" data-testid="nav-subscribe-cta">
                  <Button className="bg-brand-primary hover:bg-brand-primaryHover text-white rounded-none">Go Premium</Button>
                </Link>
              )}
              <Link to="/account" data-testid="nav-account" className="text-brand-muted hover:text-white flex items-center gap-1.5">
                <User className="h-4 w-4" />
                <span className="hidden sm:inline text-sm">{user.name || user.email}</span>
              </Link>
              <Button
                data-testid="nav-logout"
                variant="ghost"
                size="sm"
                onClick={async () => { await logout(); nav("/"); }}
                className="text-brand-muted hover:text-white hover:bg-white/10 rounded-none"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
